import {
  Avatar,
  Badge,
  Box,
  Button,
  ButtonGroup,
  Flex,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { AddIcon, EditIcon, ViewIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useData } from "../../Contexts/DataContext";
import AddEditUserModal from "./AddEditUserModal";
import { useAuth } from "../../Contexts/AuthContext";

const UserListModal = ({ isOpen, onClose }) => {
  const { setCurrentUser } = useAuth();
  const { clients, users = [] } = useData();
  const [selectedUser, setSelectedUser] = useState(null);

  const {
    isOpen: isEditOpen,
    onOpen: openEdit,
    onClose: closeEdit,
  } = useDisclosure();

  const {
    isOpen: isUserModalOpen,
    onOpen: onUserModalOpen,
    onClose: onUserModalClose,
  } = useDisclosure();

  const handleEdit = (user) => {
    setSelectedUser(user);
    openEdit();
  };

  const getClientName = (clientId) => {
    return clients.find((c) => c.id === clientId)?.name || "-";
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="gray.700" color="white">
            <Flex justify="space-between" align="center">
              <Text>Users List</Text>
              <Button
                mr={20}
                leftIcon={<AddIcon />}
                fontSize="xs"
                colorScheme="yellow"
                size="sm"
                onClick={onUserModalOpen}
              >
                Add User
              </Button>
            </Flex>
          </ModalHeader>

          <ModalCloseButton color="white" />
          <ModalBody p={0}>
            <TableContainer maxH={"65vh"} overflowY={"auto"}>
              <Table variant="simple" size={"sm"}>
                <Thead bg="gray.100">
                  <Tr>
                    <Th>Name</Th>
                    <Th>Email</Th>
                    <Th>Client</Th>
                    <Th>Roles</Th>
                    <Th>Last Log In</Th>
                    <Th textAlign={"center"}> Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {users.map((user) => (
                    <Tr key={user.id}>
                      <Td>
                        <HStack spacing={3}>
                          <Avatar name={user.name} size={"sm"} />
                          <Box>{user.name}</Box>
                        </HStack>
                      </Td>
                      <Td>{user.email}</Td>
                      <Td>{getClientName(user.clientId)}</Td>
                      <Td>
                        <HStack>
                          {user.isAdmin && (
                            <Badge colorScheme="blue">Admin</Badge>
                          )}
                          {user.isDev && (
                            <Badge colorScheme="purple">Developer</Badge>
                          )}
                          {!user.isAdmin && !user.isDev && (
                            <Badge colorScheme="gray">User</Badge>
                          )}
                        </HStack>
                      </Td>
                      <Td>
                        {user.lastLogin
                          ? new Date(user.lastLogin).toLocaleString()
                          : "—"}
                      </Td>
                      <Td textAlign={"center"}>
                        <ButtonGroup>
                          <IconButton
                            icon={<ViewIcon />}
                            aria-label="Edit User"
                            size="sm"
                            onClick={() => setCurrentUser(user)}
                          />
                          <IconButton
                            icon={<EditIcon />}
                            aria-label="Edit User"
                            size="sm"
                            onClick={() => handleEdit(user)}
                          />
                        </ButtonGroup>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
        </ModalContent>
      </Modal>

      <AddEditUserModal isOpen={isUserModalOpen} onClose={onUserModalClose} />

      {isEditOpen && (
        <AddEditUserModal
          isOpen={isEditOpen}
          onClose={() => {
            closeEdit();
            setSelectedUser(null);
          }}
          user={selectedUser}
        />
      )}
    </>
  );
};

export default UserListModal;
